

















































































































import Vue from "vue";
import store, { TaxStore } from "../services/TaxStore";
import Page from "../../../components/Page.vue";
import Tax from "../models/Tax";
import setAttribute from "../../../utils/dom";
import {
  orderBy,
  SortDescriptor,
} from "@progress/kendo-data-query";
import { t } from "@/plugins/i18n";

interface Data {
  store: TaxStore;
  skip: number;
  take: number;
  pageable: any;

  sort: SortDescriptor[];
}

const confirmationTemplate = {
  mounted() {
    setAttribute(".k-detail-cell", "colspan", "8");
  },
};

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
  },

  data(): Data {
    return {
      store,
      skip: 0,
      take: 10,
      pageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
      sort: [],
    };
  },

  async beforeMount() {
    window.scrollTo(0, 0);
    await this.store.loadTaxes();
  },

  computed: {

    columns: () => [
      { field: "name", title: t("Taxes_Adotipus") },
      { field: "degree", title: t("Taxes_Adokulcs") },
      {
        field: "isInverseTax",
        title: t("Taxes_FordAFA"),
        editor: "boolean",
        cell: "isInverseTemplate",
      },
      {
        field: "specTax",
        title: t("Taxes_SpecAfa"),
        editor: "boolean",
        cell: "SpecTaxTemplate",
      },
      {
        field: "diffTax",
        title: t("Taxes_KulAfa"),
        editor: "boolean",
        cell: "DiffTaxTemplate",
      },
      {
        field: "maxDegree",
        title: t("Taxes_MaxAdokulcs"),
        editor: "boolean",
        cell: "MaxDegreeTemplate",
      },
      {
        field: "readOnly",
        title: t("Taxes_Kotott"),
        editor: "boolean",
        cell: "ReadOnlyTemplate",
      },
      {
        field: "deleted",
        title: t("Elo"),
        editor: "boolean",
        cell: "DeletedTemplate",
      },
      { cell: "commandTemplate", width: "70px", filterable: false },
    ],

    items() {
      return orderBy(
          this.store.taxes.slice(this.skip, this.take + this.skip),
          this.sort
      );
    },

    total() {
      return this.store.taxes ? this.store.taxes.length : 0;
    },
  },

  methods: {
    pageChangeHandler(event: any) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },


    sortChange(e: { sort: SortDescriptor[] }) {
      this.sort = e.sort;
    },
    itemChange({
      dataItem,
      value,
      field,
    }: {
      dataItem: Tax;
      value: any;
      field: string;
    }) {
      const item = dataItem;
      const update = {
        [field]: value,
      };

      this.store.save(item);
    },
    showDetails(tax: Tax) {
      this.$router.push(`/tax/${tax.id}/details`);
    },

    createTax() {
      this.$router.push(`/tax/create`);
    },

    updateTax(tax: Tax) {
      this.$router.push(`/tax/${tax.id}/edit`);
    },


  },
});
